import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_service/fetch_container_scheduled_service/${container_service_id}`
    );
  },
  fetchTechnicians({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_service/fetch_container_schedule_technicians/${container_service_id}`
    );
  },
  fetchService({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_service/fetch_service/${container_service_id}`
    );
  },
  fetchAgroExporter({ container_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_service/fetch_agro_exporter/${container_service_id}`
    );
  },
  update({ container_service_id, container_schedule_technician_id, started_at, finished_at, finished, container_service_values }) {
    return RequesterV1.patch(
      `service_provider/services/container_op/edit_service/update/${container_service_id}`,
      {
        container_service: {
          container_schedule_technician_id,
          started_at,
          finished_at,
          finished,
        },
        container_service_values,
      }
    );
  },
};
